import {Link, Modal, TextContainer} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';
import {useUrl} from '@web-utilities/url';

export interface ModalProps {
  open: boolean;
  resourceName: string;
  onClose: () => void;
}

export const DisclaimerModal = ({open, resourceName, onClose}: ModalProps) => {
  const [i18n] = useI18n();
  const url = useUrl();
  const appName = i18n.translate('Common.appName');

  return (
    <Modal
      open={open}
      instant
      title={i18n.translate('DisclaimerModal.title', {
        resourceName,
        appName,
      })}
      onClose={onClose}
      primaryAction={{
        content: i18n.translate('Common.ok'),
        onAction: onClose,
      }}
    >
      <Modal.Section>
        <TextContainer>
          <p>
            {i18n.translate('DisclaimerModal.line1', {
              appName,
              poweredByGoogleLink: (
                <Link
                  removeUnderline
                  target="_blank"
                  url="https://cloud.google.com/translate"
                >
                  {i18n.translate('DisclaimerModal.poweredByGoogleLinkLabel')}
                </Link>
              ),
              googlePrivacyPolicyLink: (
                <Link
                  removeUnderline
                  target="_blank"
                  url="https://policies.google.com/privacy"
                >
                  {i18n.translate('DisclaimerModal.privacyPolicyLinkLabel')}
                </Link>
              ),
              googleTermsOfServiceLink: (
                <Link
                  removeUnderline
                  target="_blank"
                  url="https://policies.google.com/terms"
                >
                  {i18n.translate('DisclaimerModal.termsOfServiceLinkLabel')}
                </Link>
              ),
            })}
          </p>
          <p>
            {i18n.translate('DisclaimerModal.line2', {
              shopifyPrivacyPolicyLink: (
                <Link
                  removeUnderline
                  target="_blank"
                  url={url.shopifyPrivacyPolicy(i18n.language)}
                >
                  {i18n.translate('DisclaimerModal.privacyPolicyLinkLabel')}
                </Link>
              ),
              shopifyTermsOfServiceLink: (
                <Link
                  removeUnderline
                  target="_blank"
                  url={url.shopifyTermsOfService(i18n.language)}
                >
                  {i18n.translate('DisclaimerModal.termsOfServiceLinkLabel')}
                </Link>
              ),
              shopifyAcceptableUsePolicyLink: (
                <Link
                  removeUnderline
                  target="_blank"
                  url="https://www.shopify.com/legal/aup"
                >
                  {i18n.translate(
                    'DisclaimerModal.acceptableUsePolicyLinkLabel',
                  )}
                </Link>
              ),
            })}
          </p>
          <p>{i18n.translate('DisclaimerModal.line3')}</p>
          <p>{i18n.translate('DisclaimerModal.line4')}</p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};
